import { USCurrency } from 'components/ReusableComponents/FormattedPrice'

import styles from './TotalCard.module.scss'

const TotalCard = ({ invoiceDetails, taxRate }) => {
  const {
    totalTax,
    totalFixedServices,
    totalMessageFees,
    balanceForward,
    totalAmountDueWithPreviousBalance,
    discount
  } = invoiceDetails

  return (
    <div className={styles.totalCard}>
      <div className={styles.totalCardRow}>
        <div className={styles.totalCardName}>Subtotal</div>
        <div className={styles.totalCardValue}>
          <USCurrency withCode>{totalFixedServices + totalMessageFees}</USCurrency>
        </div>
      </div>
      {discount > 0 && (
        <div className={styles.totalCardRow}>
          <div className={styles.totalCardName}>Discount</div>
          <div className={styles.totalCardValue}>
            <USCurrency withCode>{discount}</USCurrency>
          </div>
        </div>
      )}
      <div className={styles.totalCardRow}>
        <div className={styles.totalCardName}>{taxRate.toString()}% sales tax</div>
        <div className={styles.totalCardValue}>
          <USCurrency withCode>{totalTax}</USCurrency>
        </div>
      </div>
      <div className={styles.totalCardRow}>
        <div className={styles.totalCardName}>Balance forward</div>
        <div className={styles.totalCardValue}>
          <USCurrency withCode>{balanceForward}</USCurrency>
        </div>
      </div>
      <div className={styles.totalCardRowHighlighted}>
        <div className={styles.totalCardName}>Total billed</div>
        <div className={styles.totalCardValue}>
          <USCurrency withCode>{totalAmountDueWithPreviousBalance}</USCurrency>
        </div>
      </div>
    </div>
  )
}

export default TotalCard
